<script>
import MainContentBanner from '@/views/MainContentBanner.vue'
import bus from 'vue3-eventbus'
import Share from '@/views/Share.vue'
import ShareTipDialog from '@/components/dialog/ShareTipDialog.vue'

export default {
  components: {
    ShareTipDialog,
    Share,
    MainContentBanner
  },
  methods: {
    showTask () {
      bus.emit('main_task', true)
    }
  },
  mounted () {
    this.$watch(
      () => this.$route.params,
      () => {
        if (this.$route.params === 1) {
          if (!this.$store.state.shareTip) {
            this.$store.commit('shareTip', true)
          }
        }
      },
      { immediate: true }
    )
  }
}

</script>

<template>
  <div id="earn_cash_page">
    <div id="banner">
      <MainContentBanner/>
    </div>
    <Share/>
  </div>
  <img src="@/assets/main_task_icon.png" class="main-task-icon" @click="showTask">

  <div v-if="this.$store.state.shareTip" class="dialog_contain">
    <ShareTipDialog/>
  </div>
</template>

<style scoped>
#earn_cash_page {
  width: 104.8rem;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#banner {
  width: 104.8rem;
  height: 35rem;
  overflow: hidden;
  border-radius: 1.6rem;
}

.main-task-icon {
  width: 18.8rem;
  height: 17.6rem;
  position: absolute;
  right: 0;
  z-index: 1;
  top: 22.8rem;
}

.main-task-icon:active {
  opacity: 0.6;
}
</style>
